import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './TakerError.scss';

const TakerError = ({ reason, icon = 'icon-custom-exit', message }) => (
  <div className={styles.container} data-e2e="survey-taker-error-container" data-testid="SurveysSpa-TakerError-SurveyErrorContainer">
    <h1 className={styles.reason} data-e2e="survey-taker-reason" data-testid="SurveysSpa-TakerError-SurveyReason">
      {reason}
    </h1>
    <div className={cx(styles.signboard, 'icon-custom-signboard')}>
      <i className={cx(styles.icon, icon)} />
    </div>
    <div className={styles.message} data-e2e="survey-taker-message" data-testid="SurveysSpa-TakerError-SurveyMessage">
      {message}
    </div>
  </div>
);

TakerError.propTypes = {
  reason: PropTypes.node,
  icon: PropTypes.string,
  message: PropTypes.node,
};

export default TakerError;
